<aura-dialog-layout [title]="'L\'adresse liée à votre DPE ne correspond pas tout à fait'">
  <div dialog-content>
    <div class="mb-6 flex flex-col gap-4">
      <div class="flex flex-col gap-1 rounded-lg bg-neutral-2 p-4">
        <span class="text-xs font-semibold tracking-wider text-neutral-9 uppercase"
          >Adresse de votre annonce</span
        >
        <span class="text-neutral-12">{{ data.currentAddress }}</span>
      </div>

      <div class="flex flex-col gap-1 rounded-lg bg-neutral-2 p-4">
        <span class="text-xs font-semibold tracking-wider text-neutral-9 uppercase"
          >Adresse identifiée ADEME (n° {{ data.ademeNumber }})</span
        >
        <span class="text-neutral-12">{{ data.ademeAddress }}</span>
      </div>
      <aura-alert [alertInput]="alertConfig"></aura-alert>

      <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
        <aura-button-card
          label="Oui, cela correspond"
          [selected]="userChoice() === 'confirm'"
          (clicked)="onSelect('confirm')"
        >
          <mat-icon icon>check</mat-icon>
          <p class="mt-2 text-center text-xs text-neutral-10">
            Nous utiliserons les données du DPE pour compléter cette étape.
          </p>
        </aura-button-card>

        <aura-button-card
          label="Non, mauvais DPE"
          [selected]="userChoice() === 'cancel'"
          (clicked)="onSelect('cancel')"
        >
          <mat-icon icon>close</mat-icon>
          <p class="mt-2 text-center text-xs text-neutral-10">
            Vous pourrez essayer avec un autre numéro ADEME.
          </p>
        </aura-button-card>
      </div>
    </div>
  </div>

  <div dialog-actions>
    <button mat-flat-button class="primary" [disabled]="!userChoice()" (click)="confirm()">Confirmer</button>
  </div>
</aura-dialog-layout>
